import React from 'react'
import PropTypes from 'prop-types'

import { Carousel } from 'components/organisms'

const IdleContent = ({ screenContent, setContentAttributes }) => (
  <Carousel contentList={screenContent} setContentAttributes={setContentAttributes} />
)

IdleContent.defaultProps = {
  screenContent: [],
  setContentAttributes: () => {},
}

IdleContent.propTypes = {
  screenContent: PropTypes.array,
  setContentAttributes: PropTypes.func,
}

export default IdleContent
